import * as React from "react";
import ErrorBoundary from "./ErrorBoundary";
import SecurityProvider from "./lib/security/components/SecurityProvider";

function PageWrapper({
  children,
  SecurableDataList = [],
  CurrentUserSecurityRoleIds = [],
  ...rest
}) {
  return (
    <SecurityProvider
      initialSecurableData={SecurableDataList}
      initialSecurityRoleIds={CurrentUserSecurityRoleIds}
    >
      <ErrorBoundary {...rest}>{children}</ErrorBoundary>
    </SecurityProvider>
  );
}

export default PageWrapper;
